module.exports = __webpack_public_path__ + "img/arrowF38235.7ae843a8.svg";